import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import type { TimelineLayerId } from 'features/mapping/mapping.constants';
import type { MapMode } from 'hooks/useMapMode';

/** Current frame (epoch ms) of the active timeline layer, `timeMs: null` while frames load. */
export type TimelineClock = {
  layerId: TimelineLayerId;
  timeMs: number | null;
} | null;

const timelineClockAtom = atom<TimelineClock>({
  key: 'TIMELINE_CLOCK',
  default: null,
});

export const useTimelineClockValue = (): TimelineClock => {
  return useRecoilValue(timelineClockAtom);
};

export const useSetTimelineClock = (): ((clock: TimelineClock) => void) => {
  return useSetRecoilState(timelineClockAtom);
};

/**
 * Active layer's frame time, or null. The clock is written in an effect, so
 * right after a layer switch it can still belong to the previous layer.
 */
export const getActiveTimelineTime = (
  mapMode: MapMode,
  clock: TimelineClock,
): number | null => {
  if (!clock || clock.layerId !== mapMode) return null;
  return clock.timeMs;
};
